import DirectoryCard from "./DirectoryCard";

export default DirectoryCard;
